import {
  ConfigProvider,
  Statistic as AntdStatistic,
  StatisticProps as AntdStatisticProps,
} from "antd";
import { styled } from "styled-components";
import { useAntTheme } from "hooks/useAntTheme";
import { forwardRef } from "react";

export type StatisticProps = AntdStatisticProps & {
  centered?: boolean;
  size?: "middle" | "large";
};
// flipped statistic
const StyledStatistic = styled(AntdStatistic)<StatisticProps>`
  display: flex;
  flex-direction: column-reverse;
  ${(props) =>
    props.centered &&
    `
      text-align: center;
    `}

  .ant-statistic-content {
    margin-bottom: -1px;
    line-height: 1;
    font-weight: 500; /* medium */
    .ant-statistic-content-suffix {
      margin-inline-start: 0;
    }
  }
  .ant-statistic-title {
    font-size: 13px;
    font-weight: 300;
    letter-spacing: -0.5px;
    line-height: 1.2;
    ${(props) =>
      props.size === "large" &&
      `
      font-size: 20px;
    `}
  }
`;
export const Statistic = forwardRef<HTMLDivElement, StatisticProps>(
  (props, ref) => {
    const { theme } = useAntTheme();
    return (
      <ConfigProvider
        theme={{
          token: {
            colorTextDescription: theme.colorText,
          },
        }}
      >
        <div ref={ref}>
          <StyledStatistic {...props} />
        </div>
      </ConfigProvider>
    );
  }
);

Statistic.displayName = "Statistic";
